<template>
    <section class="tabs">
		<NavigationTabs/>

        <div class="tab-list ov-inherit">
            <div class="tab-item ov-inherit active" data-tab="events">
                <div class="filters">
                    <div class="filters-row">
                        <div class="details-data__row">
                            <Badge class="icon-highlight bg-orange-2" check :text="$t('cal.highlighted')"/>
                        </div>
                    </div>

                    <div class="filters-row filters-fields" :class="{'filters-fields_opened': isOpenOtherFilters}">
                        <Input v-model="filters.search" :placeholder="$t('search')" clear @keypress.enter="onSubmit">
                            <template #append>
                                <IconSearch style="color: #309BFE; width: 24px"/>
                            </template>
                        </Input>

						<Select
							v-model="filters.approves"
							:options="store.approves"
							:placeholder="$t('approved')"
							clear
							multiselect
							/>

						<Select
							v-model="filters.blockchains"
							:options="store.blockchains"
							:placeholder="$t('blockchain')"
							clear
							search
							multiselect/>

						<Select
							v-model="filters.arts"
							:options="store.arts"
							:placeholder="$t('art')"
							clear
							search
							multiselect/>

						<Select
							v-model="filters.utilities"
							:options="store.utilities"
							:placeholder="$t('utilities')"
							clear
							search
							multiselect/>

						<Select
							v-model="filters.studios"
							v-model:searchRequest="searchStudiosParams.search"
							:options="studios"
							:placeholder="$t('studios')"
							clear
							search
							multiselect
							scrollLoad
							@scrollLoad="scrollLoadStudios"/>
                    </div>

                    <div class="filters-row" style="justify-content: space-between">
						<div>
<!--							<div class="range">-->
<!--								<span class="range__label headline-3">Total Supply:</span>-->
<!--								<div class="range__control">-->
<!--									<div class="range__field" data-min="1" data-max="8888" data-start="100" data-end="300"></div>-->
<!--									<div class="range__row">-->
<!--										<span class="range__data body-1"></span>-->
<!--										<i class="range__icon icon-refresh"></i>-->
<!--									</div>-->
<!--								</div>-->
<!--							</div>-->
<!--                            <div class="filters-row">-->
<!--                                <Switch-->
<!--                                    v-model="filters.complaints"-->
<!--                                    placeholder="Complaints"-->
<!--                                    @input="(e) => filters.complaints = e"-->
<!--                                />-->
<!--                                <Switch-->
<!--                                    v-model="filters.feedback"-->
<!--                                    placeholder="Feedback"-->
<!--                                    @input="(e) => filters.feedback = e"-->
<!--                                />-->
<!--                            </div>-->
						</div>
						<div class="filters-controls">
<!--                            <Button v-if="isFiltersSelected" color="red" icon @click="onClearFilters">-->
<!--                                <IconClearFilter v-if="isFiltersSelected"/>-->
<!--                            </Button>-->
							<IconClearFilter class="btn-clear-filter" v-if="isFiltersSelected" @click="onClearFilters"/>

							<div class="filters-icon filters-collapse icon-filter"
								 :class="{open: isOpenOtherFilters}"
								 @click="onOpenOtherFilters"></div>

							<Button :loading="isLoading" @click="onSubmit">{{ $t('apply') }}</Button>
<!--							<button class="btn btn-text btn&#45;&#45;border btn&#45;&#45;gr"><span class="btn__value">Apply</span></button>-->
						</div>
					</div>

					<SortOrderBy
						v-model:sort="filters.sortBy"
						v-model:order="filters.orderBy"
						:sort-items="sortItems"
						@change="onSubmit"/>
				</div>


                <div class="block-grid">
<!--					<CardEventMain v-for="event in events" :item="event"/>-->
					<template v-if="collections?.length">
						<div v-for="collection in collections" class="blocks block-card-inline">
							<div class="block-card-wrapper">
								<BlockCardCollection
									:item="collection"
								/>
							</div>
						</div>

						<div v-if="currentPage < totalPages" class="block-grid-more">
							<Button :loading="isLoading" size="l" @click="onLoadMore">{{ $t('loadMore') }}</Button>
	<!--						<button class="btn btn-text" @click="onLoadMore"><span class="btn__value">Load more</span></button>-->
						</div>
					</template>

					<div v-else class="block-grid__empty">
                        <LoaderQuad v-if="isLoading"/>
						<template v-else>{{$t('searchNoResults')}}</template>
					</div>
                </div>

            </div>
            <div class="tab-item ov-inherit" data-tab="collection"></div>
            <div class="tab-item ov-inherit" data-tab="studios"></div>
            <div class="tab-item ov-inherit" data-tab="news"></div>
        </div>
    </section>
</template>

<script>
import {useStore} from '~/stores/store';
import {useApi} from '~/composables/api';
import langRoutesExternal from "~/langRoutes";

const langRoutes = langRoutesExternal['nft-collections'].children;

export default defineNuxtComponent({
    name: 'PageCollections',
	async setup() {
		// console.log('p:collections setup()')
		definePageMeta({
			middleware: ['entities'],
		})

		const api = useApi();
		const route = useRoute();
		const store = useStore();
		const { locale } = useI18n();
		const { $helpers, $config } = useNuxtApp();
		const optionsSorter = [5, 30, 40, 50, 60, 70, 80, 90];
		const sortItems = store.sortBy.filter(item => optionsSorter.includes(item.id))
		let collections = [];
		let response = null;
		let totalPages = 0;
		let filterId = null;
		let isOpenOtherFilters = ref(false);
		let filters = reactive({
			search: '',
			approves: [],
			blockchains: [],
			arts: [],
			utilities: [],
			studios: [],
			sortBy: 5,
			orderBy: 20,
			complaints: false,
			feedback: false
		})


		const parseURL = function() {
			console.log('p:collections parseURL()', route.name, locale.value)
			const filters = {};

			if (route.name !== langRoutes['index'][locale.value].name) {
				switch (route.name) {
					case 'nft-collections-blockchain':
					case 'nft-collections-blockchain-de':
					case 'nft-collections-blockchain-es-mx':
					case 'nft-collections-blockchain-fr':
					case 'nft-collections-blockchain-jp':
					case 'nft-collections-blockchain-pt-br':
					case 'nft-collections-blockchain-ru':
					case 'nft-collections-blockchain-tr':
					{
						const obj = store.blockchains.find(item => item.slug === route.params.filterValue);

						if (obj) {
							filters.blockchains = [obj.id];
						}

						break;
					}

					case 'nft-collections-art':
					case 'nft-collections-art-de':
					case 'nft-collections-art-es-mx':
					case 'nft-collections-art-fr':
					case 'nft-collections-art-jp':
					case 'nft-collections-art-pt-br':
					case 'nft-collections-art-ru':
					case 'nft-collections-art-tr':
					{
						const obj = store.arts.find(item => item.slug === route.params.filterValue);

						if (obj) {
							filters.arts = [obj.id];
						}

						break;
					}

					case 'nft-collections-utilities':
					case 'nft-collections-utilities-de':
					case 'nft-collections-utilities-es-mx':
					case 'nft-collections-utilities-fr':
					case 'nft-collections-utilities-jp':
					case 'nft-collections-utilities-pt-br':
					case 'nft-collections-utilities-ru':
					case 'nft-collections-utilities-tr':
					{
						const obj = store.utilities.find(item => item.slug === route.params.filterValue);

						if (obj) {
							filters.utilities = [obj.id];
						}

						break;
					}
				}
			}

			return filters;
		};

		if (route.query?.filter?.length) {
			filterId = route.query.filter;
		} else {
			filters = reactive({...filters, ...parseURL()});
		}

		response = await api.collections.fetchNftCollections({
			...filters,
			filterId: filterId,
			page: 1
		});

		if (response) {
			collections = response.results.results;
			totalPages = response.results.total_pages;

			filters = reactive({...filters, ...response.filters});

			if (filters.utilities.length || filters.studios.length) {
				isOpenOtherFilters.value = true;
			}

			useSeoMeta({
				title: response.metadata.title,
				ogTitle: response.metadata.title,
				description: response.metadata.description,
				ogDescription: response.metadata.description,
				ogImage: $config.public.OG_DEFAULT_IMAGE,
			});
		}

		const arrAlternatives = [];

		for (const lang in $config.public.ALTERNATIVES) {
			arrAlternatives.push({
				rel: 'alternate',
				hreflang: lang,
				href: new URL(langRoutes['index'][lang.toLowerCase()].path, $config.public.ALTERNATIVES[lang]).toString()
			})
		}
		arrAlternatives.push({
			rel: 'alternate',
			hreflang: 'x-default',
			href: new URL(langRoutes['index']['en'.toLowerCase()].path, $config.public.ALTERNATIVES['en']).toString()
		})

		useHead({
			link: arrAlternatives
		})

		return {
			collections,
			filters,
			totalPages,
			sortItems,
			isOpenOtherFilters,
			store,
			parseURL,
			debounce: $helpers.debounce
		};
    },
    data: () => ({
		isOpenOtherFilters: false,
		isLoading: true,
        isLoadingStudios: false,
		currentPage: 1,
		totalPages: 1,
		countResults: null,
		collections: [],
		studios: [],
		searchStudios: null,
        filterId: null,
        priority: null,
		// filters: {
		// 	search: '',
		// 	approves: [],
		// 	blockchains: [],
		// 	arts: [],
		// 	utilities: [],
		// 	studios: [],
		// 	sortBy: 5,
		// 	orderBy: 20,
		// 	complaints: false,
		// 	feedback: false
		// },
		searchStudiosParams: {
			search: null,
			page: 1,
			totalPages: 1,
		},
    }),
    computed: {
        isFiltersSelected() {
            return this.filters.search?.length > 0 ||
                this.filters.approves.length ||
                this.filters.blockchains.length ||
                this.filters.arts.length ||
                this.filters.utilities.length ||
                this.filters.studios.length;
        }
    },
    watch: {
        async '$route'(newValue, oldValue) {
            console.log('%cp:collections watch() $route', 'color:red', newValue.name, JSON.stringify(this.filters), oldValue, newValue);

            if (oldValue.fullPath !== newValue.fullPath) {
                this.search = '';
				const filters = this.parseURL();

				if (newValue.query?.filter?.length) {
                    const response = await this.fetchNftCollections(1, newValue.query.filter);

                    if (response) {
                        this.setFilters(response.filters);

						if (response.filters?.studios?.length) {
							this.searchStudiosParams.page = 1;
							await this.fetchStudiosAutocomplete();
						}

                        if (this.filters.utilities.length || this.filters.studios.length) {
                            this.isOpenOtherFilters = true;
                        }
                    }

                    // this.setDateRange(this.store.quick_access.today.start, this.store.quick_access.today.end);
                } else {
					this.setFilters(filters);

					await this.fetchNftCollections(1);
                }

            }
            // this.news.previousRoute = oldValue;
        },
		'searchStudiosParams.search'() {
			this.searchStudiosParams.page = 1;
			const _this = this;
			this.debounce(() => {
				_this.fetchStudiosAutocomplete()
			}, 100)();
		},
    },
	async mounted() {
		// console.log('p:collections mounted()')

		await this.fetchStudiosAutocomplete();
		this.isLoading = false;
    },
    methods: {
		onOpenOtherFilters() {
			this.isOpenOtherFilters = !this.isOpenOtherFilters;
		},
        onClearFilters() {
            this.filters.search = '';
            this.filters.approves = [];
            this.filters.blockchains = [];
            this.filters.arts = [];
            this.filters.utilities = [];
            this.filters.studios = [];
        },
		async onSubmit() {
			this.currentPage = 1;
			const response = await this.fetchNftCollections(1);

            if (response) {
                this.filterId = response.filter_id ?? null;
                this.priority = response.priority ?? null;

                // if (this.filterId) {
                this.setUrl();
                // }
            }
		},
		async onLoadMore() {
			if (this.currentPage <= this.totalPages) {
				await this.fetchNftCollections(this.currentPage + 1);

				// if (collections) {
				// 	this.collections = [...this.collections, ...collections];
				// }
			}
		},
        setUrl() {
            console.log('setUrl', this.priority, this.filterId, this.$route)
            // if (this.$route.params?.filterValue?.length) {
            //
            // }

            // let isSend = false;
            const obj = {
                path: langRoutes['index'][this.$i18n.locale].path
            };
            // console.log('this.$route.name', this.$route.name, langRoutes['index'][this.$i18n.locale].name)
            if (this.$route.name !== langRoutes['index'][this.$i18n.locale].name && !this.isFiltersSelected) {
                this.$router.push(obj);
                return;
            }

            if (this.priority) {
                obj.path = `${langRoutes['index'][this.$i18n.locale].path}${this.priority.key}/${this.priority.value}`;
                // isSend = true;
            }

            if (this.filterId) {
                obj.query = {filter: this.filterId};
                // isSend = true;
            }
            // history.pushState(obj, obj.path, obj.path)
            // if (isSend) {
                console.log('push', obj)
                this.$router.push(obj);
            // }
        },
        setFilters(filters) {
            // console.log('setFilters', filters)

            if (filters?.search) {
                this.filters.search = filters.search;
            }

            if (filters?.approves) {
                this.filters.approves = filters.approves;
            } else {
				this.filters.approves = [];
			}

            if (filters?.blockchains) {
                this.filters.blockchains = filters.blockchains;
			} else {
				this.filters.blockchains = [];
			}

            if (filters?.arts) {
                this.filters.arts = filters.arts;
			} else {
				this.filters.arts = [];
			}

            if (filters?.utilities) {
                this.filters.utilities = filters.utilities;
			} else {
				this.filters.utilities = [];
			}

            if (filters?.studios) {
                this.filters.studios = filters.studios;
			} else {
				this.filters.studios = [];
			}

            if (filters?.complaints) {
                this.filters.complaints = filters.complaints;
            }

            if (filters?.feedback) {
                this.filters.feedback = filters.feedback;
            }

            if (filters?.sort_by) {
                this.filters.sortBy = filters.sort_by;
            }

            if (filters?.order_by) {
                this.filters.orderBy = filters.order_by;
            }
        },
		async fetchNftCollections(page = 1, filterId = null) {
            // console.log('fetchNftCollections()')
			this.isLoading = true;
			const api = useApi();

            try {
				const response = await api.collections.fetchNftCollections({
					...this.filters,
                    filterId: filterId,
					page: page
				});

                if (response) {
                    if (page > this.currentPage) {
                        this.collections = [...this.collections, ...response.results.results];
                    } else {
                        this.collections = response.results.results;
                    }

                    this.totalPages = response.results.total_pages;
                    this.currentPage = page;

                    return response;
                }
            } catch (e) {
                console.error(e)
            } finally {
				this.isLoading = false;
			}
        },
		async fetchStudiosAutocomplete() {
            try {
                this.isLoadingStudios = true;
                const api = useApi();
                const response = await api.studios.fetchStudiosAutocomplete({
                    ...this.searchStudiosParams,
                    ids: this.filters.studios,
                });

                if (response) {
                    if (this.searchStudiosParams.page === 1) {
                        this.studios = response.results;
                        this.searchStudiosParams.totalPages = response.total_pages;
                    } else {
                        this.studios = [...this.studios, ...response.results];
                    }
                }
			} catch (e) {
				console.log('Not found studios autocomlete')
			} finally {
                this.isLoadingStudios = false;
            }
		},
		scrollLoadStudios() {
			if (this.searchStudiosParams.page < this.searchStudiosParams.totalPages) {
				this.searchStudiosParams.page = this.searchStudiosParams.page + 1;
				this.fetchStudiosAutocomplete();
			}
		}
	},
})
</script>

<style lang="scss" scoped>
.filters-fields {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	flex-grow: 1;

	.form-item:nth-child(5),
	.form-item:nth-child(6)
	{
		display: none;
	}

	&_opened {
		.form-item:nth-child(5),
		.form-item:nth-child(6)
		{
			display: inline-flex;
		}
	}

	@media (max-width: 1200px) {
		grid-template-columns: 1fr 1fr 1fr;

		.form-item:nth-child(5),
		.form-item:nth-child(6)
		{
			display: inline-flex;
		}
	}

	@media (max-width: 900px) {
		grid-template-columns: 1fr 1fr;

		.form-item:nth-child(5),
		.form-item:nth-child(6)
		{
			display: none;
		}

		&_opened {
			.form-item:nth-child(5),
			.form-item:nth-child(6)
			{
				display: inline-flex;
			}
		}
	}

	@media (max-width: 530px) {
		grid-template-columns: 1fr;

		.form-item:nth-child(5),
		.form-item:nth-child(6)
		{
			display: none;
		}

		&_opened {
			.form-item:nth-child(5),
			.form-item:nth-child(6)
			{
				display: inline-flex;
			}
		}
	}
}
</style>
